<template>
  <div class="streaming">
    <AppHeader />
    

    <div class="filter">

      <div class="filter-container">
        <span class="breadcrumb">
          <span @click="toHome()">教研新空间</span> > 名师公开课
        </span>
        <el-divider></el-divider>

        <h1 class="title">
          <img src="../assets/img/icon-streaming.png" alt="" /> 名师公开课
        </h1>
        <AppCheckbox v-model="params.status" label="直播状态：" :list="array2" label-key="name" value-key="code" />
      </div>
    </div>
    <div class="list">
      <AppStreaming :item='item' v-for="(item, index) in list" :key="index" />
    </div>

    <div class="center">
      <el-pagination background prev-text='上一页' next-text='下一页' layout="prev, pager, next"
        @current-change='getStreamingList' :current-page.sync="params.pageNum" :page-size="params.pageSize"
        :total="total">
      </el-pagination>
    </div>
    <AppFoot showCopyRight showLink :showContect="false" />

  </div>
</template>
<script>
export default {
  name: "",
  props: {},
  data() {
    return {
      status: "",
      params: {
        pageNum: 1,
        pageSize: 6,
        status: "",
        sortType: `start_time:desc`
      },
      total: 0,
      list: [],
      array2: [
        { name: "未开始", code: "0" },
        { name: "正在进行", code: "1" },
        { name: "已结束", code: "2" },
      ],
    };
  },
  watch: {
    "params.status"() {
      this.params.pageNum = 1;
      this.getStreamingList();
    },
  },
  methods: {
    // 获取公开课列表
    async getStreamingList() {
      try {
        let { code, data } = await this.$api.live.listLive(this.params);
        this.list = code === "1" ? data.rows : [];
        this.total = code === "1" ? data.totalSize : 0;
      } catch (error) {
        this.list = [];
        this.total = 0;
      }
    },
    toHome() {
      this.$router.push({ name: "home" });
    },
  },
  mounted() {
    this.getStreamingList();
  },
};
</script>
<style scoped lang="less">
.streaming {
  background: #f5f5f5;
  .filter {
    background: #fff;
    overflow: hidden;

    .filter-container {
      overflow: hidden;
      width: 1200px;
      margin: 0 auto 10px;
      padding-top: 20px;
      .breadcrumb {
        font-size: 14px;
        color: #606266;
        span:hover {
          color: #409eff;
          cursor: pointer;
        }
      }
      h1.title {
        display: flex;
        align-items: center;
        margin-top: 20px;
        font-size: 24px;
        font-family: MicrosoftYaHei;
        color: #262626;
        img {
          width: 36px;
          height: 36px;
          margin-right: 16px;
        }
      }
    }
    .app-checkbox {
      border-top: 1px solid #f0f0f0;
      margin-top: 20px;
      padding-top: 20px;
    }
  }
  .list {
    overflow: hidden;
    width: 1200px;
    margin: 20px auto 10px;
    .app-streaming {
      &:nth-child(2n) {
        margin-right: 0;
      }
    }
  }
  .center {
    text-align: center;
    margin: 20px 0;
  }
}
</style>
